import type { FormEvent, ReactNode } from "react";
import clsx from "clsx";

/** An input's own message when the browser finds it missing or malformed, in the app's language rather than the browser's. */
export function says(message: string) {
  return {
    onInvalid: (e: FormEvent<HTMLInputElement>) => e.currentTarget.setCustomValidity(message),
    onInput: (e: FormEvent<HTMLInputElement>) => e.currentTarget.setCustomValidity(""),
  };
}

export function Field(props: { label?: ReactNode; error?: string; hint?: ReactNode; children: ReactNode; className?: string; required?: boolean }) {
  return (
    <label className={clsx("block", props.className)}>
      {props.label && (
        <span className="label">
          {props.label}
          {props.required && <span className="ms-0.5 text-danger" aria-hidden>*</span>}
        </span>
      )}
      {props.children}
      {props.error ? (
        <span role="alert" className="mt-1 block text-[12px] text-danger">{props.error}</span>
      ) : props.hint ? (
        <span className="mt-1 block text-[12px] text-ink-3">{props.hint}</span>
      ) : null}
    </label>
  );
}

export function FormGrid({ children, cols = 2 }: { children: ReactNode; cols?: 1 | 2 | 3 }) {
  return (
    <div className={clsx("grid gap-x-4 gap-y-3", cols === 2 && "sm:grid-cols-2", cols === 3 && "sm:grid-cols-3")}>{children}</div>
  );
}

export function Checkbox({ label, checked, onChange, disabled }: { label: ReactNode; checked: boolean; onChange: (v: boolean) => void; disabled?: boolean }) {
  return (
    <label className="inline-flex cursor-pointer items-center gap-2 select-none">
      <input type="checkbox" className="size-4 accent-ledger" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
      <span>{label}</span>
    </label>
  );
}
